import { makeEroadStyles } from "../../../styles";

const useStyles = makeEroadStyles(
  (theme) => ({
    root: {
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      textAlign: "center",
    },

    icon: {
      margin: theme.spacing(3),
      fontSize: "4.8rem",

      "& svg": {
        fill: theme.colors.eroadBrand,
      },
    },
  }),
  { name: "PageError" },
);

export { useStyles };
